<template>
  <div class="grid-x grid-margin-x content">
    <div class="small-12 cell social-icons">
        <font-awesome-icon
          :icon="facebook"
          size="2x"
          class="social-logo"
          @click="openFacebook" />
        <font-awesome-icon
          :icon="instagram"
          size="2x"
          class="social-logo"
          @click="openInstagram" />
        <font-awesome-icon
          :icon="twitter"
          size="2x"
          class="social-logo"
          @click="openTwitter" />
    </div>
    <div class="small-12 cell holding-page">
      <div class="small-12 cell">
        <h1 class="main-title">Dan Flynn</h1>
      </div>
      <div class="small-12 cell">
        <h4 class="sub-title">Digital Marketing and Content Creation</h4>
      </div>
      <br>
      <br>
      <div class="small-12 cell">
        <h4 class="call-to-action">Full website coming soon...</h4>
      </div>
    </div>
  </div>
</template>

<script>

import { faFacebook, faInstagram, faTwitter } from
  '@fortawesome/free-brands-svg-icons';

export default {
  name: 'Home',
  data() {
    return {
      facebook: faFacebook,
      instagram: faInstagram,
      twitter: faTwitter,
    };
  },
  methods: {
    openFacebook() {
      window.open('https://www.facebook.com/dan.flynn.777363', '_blank');
    },
    openInstagram() {
      window.open('http://instagram.com/danuka1990', '_blank');
    },
    openTwitter() {
      window.open('http://www.twitter.com/danukauk', '_blank');
    },
  },
};
</script>

<style lang="scss">

  .content {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    justify-content: center;
    position: fixed;
    width: 100%;
  }

  .home {
    background-color: #FFFFFF;
  }

  .social-icons {
    align-self: flex-start;
    height: 10%;
    margin-bottom: 0;
    margin-top: 0;
    position: absolute;
    text-align: right;
  }

  .social-logo {
    color: #BBBBBB;
    cursor: pointer;
    padding: 0.5em;

    &:hover {
      color: #2c3e50;
    }

  }

  .holding-page {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 90%;
    justify-content: center;
    margin-bottom: 0;
    margin-top: 0;
  }

  %title {
    color: #BBBBBB;
    font-family: 'Myriad Pro', sans-serif;
    letter-spacing: 0.05em;
    line-height: 1.5;
    text-transform: uppercase;
  }

  .main-title {
    @extend %title;
    font-size: 3em;
    margin-bottom: 0.1em;

    @media screen and (max-width: 640px) {
      font-size: 1.75em;
    }

    @media screen and (max-width: 400px) {
      font-size: 1.25em;
    }
  }

  .sub-title {
    @extend %title;
    color: #2c3e50;
    font-size: 1.25em;
    margin-top: 0;

    @media screen and (max-width: 640px) {
      font-size: 0.85em;
    }

    @media screen and (max-width: 400px) {
      font-size: 0.65em;
    }

  }

  .call-to-action {
    @extend %title;
    color: #BBBBBB;
    font-size: 1.25em;
    margin-top: 0;
    text-transform: none;

    @media screen and (max-width: 640px) {
      font-size: 0.85em;
    }

    @media screen and (max-width: 400px) {
      font-size: 0.65em;
    }

  }

</style>
